import { InputForm } from "../types"

// ─── Legacy columns (kept for backward compatibility) ────────────
export const APPOINTMENT_LIST_COLUMNS = [
    {
        field: 'date',
        headerName: 'Date',
        width: '30%',
    },
    {
        field: 'status',
        headerName: 'Status',
        width: '30%',
    },
    {
        field: 'address',
        headerName: 'Address',
        width: '40%',
    },
]

// ─── Enriched appointment columns ─────────────────────────────────

/** In-Progress section columns (Active & Future tab) */
export const IN_PROGRESS_COLUMNS = [
    { field: 'startDateTime', headerName: 'Scheduled Time' },
    { field: 'title', headerName: 'Title' },
    { field: 'userName', headerName: 'User Name' },
    { field: 'location', headerName: 'Appt Location' },
    { field: 'checkInLocation', headerName: 'Checked-In Location' },
    { field: 'checkIn', headerName: 'Check-In' },
    { field: 'elapsed', headerName: 'Elapsed' },
    { field: 'liveStatus', headerName: 'Status' },
];

/** Upcoming section columns (Active & Future tab) */
export const UPCOMING_COLUMNS = [
    { field: 'startDateTime', headerName: 'Scheduled Time' },
    { field: 'title', headerName: 'Title' },
    { field: 'userName', headerName: 'User Name' },
    { field: 'location', headerName: 'Appt Location' },
    { field: 'duration', headerName: 'Duration' },
    { field: 'lastPing', headerName: 'Last Ping' },
];

/** Past tab columns */
export const PAST_COLUMNS = [
    { field: 'startDateTime', headerName: 'Scheduled Time' },
    { field: 'title', headerName: 'Title' },
    { field: 'userName', headerName: 'User Name' },
    { field: 'location', headerName: 'Appt Location' },
    { field: 'checkInLocation', headerName: 'Checked-In Location' },
    { field: 'checkIn', headerName: 'Check-In' },
    { field: 'checkOut', headerName: 'Check-Out' },
    { field: 'pastStatus', headerName: 'Status' },
];

// ─── Filter inputs ────────────────────────────────────────────────

export const APPOINTMENT_FILTER_INPUTS: InputForm[] = [
    {
        label: 'User Name',
        id: 'userName',
        type: 'text',
        required: false,
        placeholder: 'Filter by user name',
        grid: {
            xs: 4,
            sm: 4,
            md: 4,
        },
    },
    {
        label: 'Title',
        id: 'title',
        type: 'text',
        required: false,
        placeholder: 'Filter by appointment title',
        grid: {
            xs: 4,
            sm: 4,
            md: 4,
        },
    },
]

/** Additional filter inputs for Past tab */
export const PAST_APPOINTMENT_FILTER_INPUTS: InputForm[] = [
    {
        label: 'User Name',
        id: 'userName',
        type: 'text',
        required: false,
        placeholder: 'Filter by user name',
        grid: { xs: 3, sm: 3, md: 3 },
    },
    {
        label: 'Title',
        id: 'title',
        type: 'text',
        required: false,
        placeholder: 'Filter by appointment title',
        grid: { xs: 3, sm: 3, md: 3 },
    },
    {
        label: 'Status',
        id: 'status',
        type: 'select',
        required: false,
        placeholder: 'All Statuses',
        options: [
            { value: 'all', label: 'All Statuses' },
            { value: 'completed', label: 'Completed' },
            { value: 'escalated', label: 'Escalated' },
            { value: 'no-checkin', label: 'No Check-In' },
            { value: 'cancelled', label: 'Cancelled' },
        ],
        grid: { xs: 3, sm: 3, md: 3 },
    },
    {
        label: 'Time Period',
        id: 'timePeriod',
        type: 'select',
        required: false,
        placeholder: 'Last 30 Days',
        options: [
            { value: '7', label: 'Last 7 Days' },
            { value: '30', label: 'Last 30 Days' },
            { value: '90', label: 'Last 90 Days' },
        ],
        grid: { xs: 3, sm: 3, md: 3 },
    },
]
